import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from "react-router-dom";

import {
    IonContent,
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
    IonButton,
    IonRow,
    IonCol,
    IonIcon,
    IonPopover,
    IonItemDivider,
    IonItem,
    IonInput,
    IonLabel,
    IonList
} from '@ionic/react';
import ExploreContainer from '../components/ExploreContainer';
import './Forno.css';
import IForno from '../interfaces/IForno';


/*ICONS */
import { addCircle, informationOutline, logoStackoverflow } from 'ionicons/icons';
import { chevronBackCircle } from 'ionicons/icons';
import { save } from 'ionicons/icons';
import { close } from 'ionicons/icons';
import { play } from 'ionicons/icons';

const Forno: React.FC = () => {
    var history = useHistory();




    const [elencoLavori, setElencoLavori] = useState<Array<IForno>>([]);
    const elencoRef = useRef(elencoLavori);
    elencoRef.current = elencoLavori;

    useEffect(() => {

        var dati: Array<IForno> = [
            {
                id_lavorazione: 1,
                titolare: 'Mario',
                prodotto: 'Margherita',
                forno: null,
                tempo_cottura_secondi: 180,
                orario_avvio: null,
                tempo_cottura_passato: null
            },
            {
                id_lavorazione: 4,
                titolare: 'Mario',
                prodotto: 'Margherita',
                forno: null,
                tempo_cottura_secondi: 180,
                orario_avvio: null,
                tempo_cottura_passato: null
            },
            {
                id_lavorazione: 5,
                titolare: 'Mario',
                prodotto: 'Margherita',
                forno: null,
                tempo_cottura_secondi: 180,
                orario_avvio: null,
                tempo_cottura_passato: null
            },
            {
                id_lavorazione:2,
                titolare: 'Roberto',
                prodotto: 'Bufala',
                forno: null,
                tempo_cottura_secondi: 220,
                orario_avvio: null,
                tempo_cottura_passato: null
            },
            {
                id_lavorazione: 3,
                titolare: 'Giulia',
                prodotto: 'Napoli',
                forno: null,
                tempo_cottura_secondi: 10,
                orario_avvio: null,
                tempo_cottura_passato: null
            }

        ]

        setElencoLavori(dati);


        const timer = setInterval(() => { var dati = aggiornaTimer(elencoRef.current); setElencoLavori(dati); }, 1000); 

        return () => clearInterval(timer);

    }, []);



const trovaColore = (forno: number, forno_selezionato:number|null) =>{

    
    if (forno === forno_selezionato) {
        return "#a2282a";
    }
    return '#B9B9B9';

}




const impostaForno = (id_lavorazione: number,  forno:number) =>{

    var dati = JSON.parse(JSON.stringify(elencoLavori));

    for (var i=0;i<dati.length;i++) {
        var lavorazione = dati[i];
        if (lavorazione.id_lavorazione === id_lavorazione) {
            lavorazione.forno = forno;
            var orario_attuale = Math.floor(new Date().getTime()/1000.0);
            lavorazione.orario_avvio = orario_attuale;
            lavorazione.tempo_cottura_passato = 0;
            setElencoLavori(dati);
            return;
        }
    }


}

const aggiornaTimer = (dati_old: any) => {

    console.log('timer');

    var dati = JSON.parse(JSON.stringify(dati_old));

    for (var i=0;i<dati.length;i++) {
        var lavorazione = dati[i];

        if (lavorazione.orario_avvio != null) {
            var orario_attuale = Math.floor(new Date().getTime()/1000.0);
            lavorazione.tempo_cottura_passato = orario_attuale - lavorazione.orario_avvio;
        }
    }

    return dati;

}

const minutiRimanenti = (totali: number|null , passati: number|null) => {



    if (totali==null) return "";
    if (passati==null) return "";

    var rimanenti = totali - passati;

    if (rimanenti<0)  {
        return "FINE";
    }

    var minutes = Math.floor(rimanenti / 60);
    var seconds = rimanenti - minutes * 60;

    function str_pad_left(s:number,pad:string,length:number) {
        return (new Array(length+1).join(pad)+s).slice(-length);
    }
    
    var finalTime = str_pad_left(minutes,'0',2)+':'+str_pad_left(seconds,'0',2);
    return finalTime;

}


    return (
        <>
            <IonPage >
                <ExploreContainer name="Home page" />

                <IonHeader style={{ height: "6%" }}>

                    <IonToolbar style={{ height: "100%" }} class={'host'}>
                        <IonRow style={{ height: "100%" }}>
                            
                            <IonCol size="12" >
                                <IonTitle class={'background-content'} style={{ fontSize: "30px", textAlign: "center" }}>Elenco lavoro</IonTitle>
                            </IonCol>

                        </IonRow>
                    </IonToolbar>

                </IonHeader>

                <IonContent class={'background-content'} fullscreen >



                    <IonRow class={'marginRigaForno'} style={{ marginTop: "40px", }}>

                        <IonCol size="2" style={{ paddingLeft: "10px", height: "15%", fontSize: "27px", backgroundColor: "#a2282a", color: "white" }}> <div style={{ textAlign: "center" }}>Titolare</div></IonCol>

                        <IonCol size="3" style={{ paddingLeft: "10px", height: "15%", fontSize: "27px", backgroundColor: "#a2282a", color: "white" }}> <div style={{ textAlign: "center" }}>Prodotto</div></IonCol>

                        <IonCol size="5" style={{ paddingLeft: "10px", height: "15%", fontSize: "27px", backgroundColor: "#a2282a", color: "white" }}><div style={{ textAlign: "center" }} >Start</div>

                      



                        </IonCol>

                        <IonCol size="2" style={{ paddingLeft: "10px", height: "15%", fontSize: "27px", backgroundColor: "#a2282a", color: "white" }}><div style={{ textAlign: "center" }} >Timer</div> </IonCol>

                    </IonRow>


                    {elencoLavori.map(lavoro =>
                        <IonRow class={'marginRigaForno'} >

                            <IonCol size="2" class={'borderTab'} style={{ borderLeft: "2px solid gray", paddingTop: "15px", paddingLeft: "10px", fontSize: "28px", backgroundColor: "white" }}> <div style={{ textAlign: "center",paddingTop:"15%" }}>{lavoro.titolare}</div></IonCol>

                            <IonCol size="3" class={'borderTab'} style={{ paddingTop: "15px", paddingLeft: "10px", fontSize: "28px", backgroundColor: "white" }}> <div style={{ textAlign: "center" ,paddingTop:"8%"}}>{lavoro.prodotto} </div></IonCol>

                         

                        <IonCol size="5" class={'borderTab'} style={{ backgroundColor: "white", textAlign: "center" }} >
                            <IonRow  >
                                <IonCol  size="2">
                                    <IonButton size="small" onClick={() => { impostaForno(lavoro.id_lavorazione, 1); }} class={'btnForni'} style={{ height: "auto"}}>
                                        <IonIcon src="../assets/icon/forno1.svg" style={{backgroundColor:trovaColore(1, lavoro.forno), color: "white",fontSize: "50px" ,borderRadius:"12px" }}></IonIcon>
                                    </IonButton>
                                </IonCol>
                                &nbsp; &nbsp; &nbsp; 
                                 <IonCol  size="2">
                                    <IonButton size="small" onClick={() => { impostaForno(lavoro.id_lavorazione, 2); }} class={'btnForni'} style={{ height: "auto"}}>
                                        <IonIcon  src="../assets/icon/forno2.svg" style={{backgroundColor:trovaColore(2, lavoro.forno), color: "red", fontSize: "50px",borderRadius:"12px" }}></IonIcon>
                                    </IonButton>
                                </IonCol >
                                &nbsp; &nbsp; &nbsp;
                                 <IonCol  size="2">
                                        <IonButton size="small" onClick={() => { impostaForno(lavoro.id_lavorazione, 3); }} class={'btnForni'} style={{ height: "auto" }}>
                                            <IonIcon src="../assets/icon/forno3.svg"  style={{ backgroundColor:trovaColore(3, lavoro.forno), color: "white", fontSize: "50px",borderRadius:"12px"  }}></IonIcon>
                                        </IonButton>
                                 </IonCol>
                                 &nbsp; &nbsp; &nbsp;
                                <IonCol  size="2">
                                    <IonButton size="small" onClick={() => { impostaForno(lavoro.id_lavorazione, 4); }} class={'btnForni'}  style={{ height: "auto"}}>
                                        <IonIcon  src="../assets/icon/forno4.svg"  style={{backgroundColor:trovaColore(4, lavoro.forno), color: "black", fontSize: "50px",borderRadius:"12px"  }}></IonIcon>
                                    </IonButton>
                                 </IonCol>

                            </IonRow>
                        </IonCol>


                            <IonCol size="2" class={'borderTab'} style={{ paddingTop: "15px", paddingLeft: "10px", fontSize: "28px", backgroundColor: "white" }}><div style={{ textAlign: "center",paddingTop:"15%" }} >{minutiRimanenti(lavoro.tempo_cottura_secondi,lavoro.tempo_cottura_passato)}</div> </IonCol>


                        </IonRow>
                    )}

                </IonContent>

            </IonPage>



        </>
    );
    
                    
};


export default Forno;
